(function (Drupal) {
  Drupal.behaviors.thirdPartyCookiesNotAccepted = {
    attach: function (context, settings) {
      function getKlaroConsent() {
        const match = document.cookie.match(/klaro=([^;]+)/);
        if (match) {
          try {
            return JSON.parse(decodeURIComponent(match[1]));
          } catch (e) {
            console.warn('Could not parse Klaro cookie:', e);
          }
        }
        return null;
      }

      // Check if the third_party_services consent is not given and show the overlay if so
      const klaroConsent = getKlaroConsent();
      const hasThirdPartyConsent = klaroConsent?.third_party_services === true;
      if (
        !hasThirdPartyConsent
      ) {
        document.body.classList.add("show-cookie-consent-overlay");
      } else {
        document.body.classList.remove("show-cookie-consent-overlay");
      }

    document.addEventListener('click', (event) => {
      const target = event.target;
      // IF cm-btn is clicked, reload the page to apply new consent settings
      if (target.closest('.cm-btn') && !target.closest('.cm-btn-lern-more')) {
        window.location.reload();
      }
    });
  }
};
})(Drupal);
